import React, { useState, useEffect } from 'react';
import useAPI from '../../../api';
import { Stack } from '@mui/material';
import { FullSizeColumn } from '../../../Components/FlexBox';
import StageStep from './StageStep';
import getColorHeatByIndex from '../../Kanban/Utils/getColorHeatByIndex';
import AddStageStep from './AddStageStep';
import { useSetAtom } from 'jotai';
import { openSnackbarAdviseAtom } from '../../../Atoms';
import { useIntl } from 'react-intl';

const StagesConfiguration = function StagesConfiguration() {
  const intl = useIntl();
  const API = useAPI();
  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);
  const [stages, setStages] = useState([]);

  useEffect(() => {
    API.getCampaignDividers(
      (result) => {
        setStages(result);
      },
      () => {}
    );
  }, []);

  const handleAddStage = ({ name, advancementThreshold, description }) => {
    API.addCampaignDivider(
      { name, advancementThreshold, description },
      (result) => {
        setStages((prevStages) => [...prevStages, result]);
      },
      () => {
        openSnackbar({
          message: intl.messages.ERROR_ADDING_STAGE,
          severity: 'error',
        });
      }
    );
  };

  const handleEditStage = (CampaignDivider) => {
    API.updateCampaignDivider(
      CampaignDivider,
      (result) => {
        setStages((prevStages) => {
          const updatedStages = prevStages.map((stage) =>
            stage.id === result.id ? result : stage
          );
          return updatedStages;
        });
      },
      () => {
        openSnackbar({
          message: intl.messages.ERROR_EDITING_STAGE,
          severity: 'error',
        });
      }
    );
  };

  const handleDeleteStage = (id) => {
    API.deleteCampaignDivider(
      id,
      () => {
        setStages((prevStages) =>
          prevStages.filter((stage) => stage.id !== id)
        );
      },
      () => {
        openSnackbar({
          message: intl.messages.ERROR_DELETING_STAGE,
          severity: 'error',
        });
      }
    );
  };

  return (
    stages && (
      <FullSizeColumn
        sx={{ padding: '24px', height: '100%', overflow: 'auto' }}
      >
        <Stack spacing={2} direction="column" sx={{ width: '50%' }}>
          {stages
            .sort((a, b) => a.advancementThreshold - b.advancementThreshold)
            .map(
              (
                {
                  id,
                  name,
                  advancementThreshold,
                  isSystem,
                  description,
                  lowerThreshold,
                },
                index
              ) => (
                <>
                  {index === stages.length - 1 &&
                    stages[index - 1]?.advancementThreshold < 100 && (
                      <AddStageStep
                        onSave={handleAddStage}
                        minValue={stages[index - 1]?.advancementThreshold}
                      />
                    )}
                  <StageStep
                    key={id}
                    id={id}
                    isFirst={index === 0}
                    isLast={index === stages.length - 1}
                    lowerValue={lowerThreshold}
                    value={advancementThreshold}
                    isSystem={isSystem}
                    title={name}
                    description={description}
                    onDelete={handleDeleteStage}
                    onEdit={handleEditStage}
                    color={getColorHeatByIndex(index + 1, stages.length + 2)}
                  />
                </>
              )
            )}
        </Stack>
      </FullSizeColumn>
    )
  );
};

export default StagesConfiguration;
